import react from "react";
import "./Experiences.css";
import ExperienceCard from "./ExperienceCard";
import imgSAP from "../media/sapoffice.jpg";
import imgUKG from "../media/ukgbackground.png";
import imgNetvyne from "../media/netvyneScreen.png";
import imgSCE from "../media/sceScreen.png";
import imgHaven from "../media/havenScreen.png";
import imgFoodify from "../media/foodifyScreen.png";
import imgBeezwax from "../media/beezwaxBackground.jpg";
import imgCanvas from "../media/canvasScreen.png";

export default function Experiences() {
  //sap office image: https://news.sap.com/sea/files/2021/11/30/SAP-Reception-1536x1152.jpg
  const experienceData = [
    {
     name: "Canvas AI (YC F24)",
     description:
        " I joined Canvas AI in the fall of 2024 as the Founding Engineer. I work on bringing AI Agents to automate work done in the SDR, Customer Success,and Account Manager space. I'm responsible for driving feature development, managing deployment environments, design, on-call product support/hotfixes, performance monitoring, database management, API integrations, session data & metrics, and more!",
      image: imgCanvas,
      link: "https://www.canvas.inc/",
      location: "San Francisco, CA",
      linkedin: "https://www.linkedin.com/company/canvasai/",
      github: null,
    },
    {
     name: "Beezwax",
     description:
        " I joined Beezwax fall of 2022 as a frontend-focused Full-stack Developer where I worked on various teams and with clients of different sizes to build end-to-end products. Upon joining, I worked closely with the Beezwax C-suite and Marketing team to develop new features for the Customer Engagement Tool. My largest project was a ground-up rewrite of client JobElephant's Finance Operations Management System, where I developed over 15 screens & 100+ components for invoice management, search, payment-transaction reconciliation, invoice splitting, messaging, user management, ad campaign management, Intuit integration/syncing and more, as well as developing the entire UI Design System from scratch with 65+ custom and theme-consistent web elements to pixel-perfect standards",
      image: imgBeezwax,
      link: "https://www.beezwax.net/",
      location: "Cupertino, CA",
      linkedin: "https://www.linkedin.com/company/beezwax-datatools-inc.",
      github: null,
    },
    {
      name: "UKG",
      description:
        " I interned in the fall of 2021 for 15 weeks as a member of the Recruitment team, responsible for the public facing job listings features of the UKG PRO Product. I built features across the stack directly on their cloud-based product, using React, .Net, & MongoDB",
      image: imgUKG,
      link: "https://www.ukg.com/",
      location: "San Jose, CA",
      linkedin: "https://www.linkedin.com/company/ukg",
      github: null,
    },
    {
      name: "SAP",
      description:
        "SAP, where I interned in the summer of 2021 for 14 weeks as a member of the Payroll team within SAP SuccessFactors, responsible for handling global payroll as part of their cloud-based HR Product offering. I built an administrative web application used internally at SAP to manage data across their development and testing environments and automate data uploading. My application was built using React & Node JS, supports all 41 payroll regions, integrates with 10+ services within SAP's Cloud Software, speeds up engineer's workflow from 30 to 2 minutes, and is used today by over 100 engineers, managers, & product designers across various teams at SAP.",
      image: imgSAP,
      link: "https://www.sap.com/products/hcm.html",
      linkedin: "https://www.linkedin.com/company/sapsuccessfactors",
      location: "Palo Alto, CA",
      github: null,
    },
    {
      name: "Haven",
      description:
        "Haven, a full-stack web project to connect cyclists with great businesses and places across their city. Logged-in users can search, review & rate local places. Built using the MERN Stack (MongoDB, Express.js, React.js, Node.js), Google Places & Auth API, MongoDb Atlas, and AWS.",
      image: imgHaven,
      link: "https://github.com/mohammadsleiman/haven",
      linkedin: "https://linkedin.com/company/ridewithhaven",
      location: "Campbell, CA",
      github: "https://github.com/mohammadsleiman/haven",
    },
    {
      name: "Netvyne",
      description:
        "Netvyne, a startup I co-founded to bring a comment section to every url on the internet. Built using HTML/CSS/JS, Flask, and PostgreSQL, this chrome extension injects a feature-rich, moderated comment section right into the HTML of every webpage. Through the main web application, users can add friends, share content & thoughts, and discover content through a feed.",
      image: imgNetvyne,
      link: "https://www.netvyne.com/",
      location: "Saratoga, CA",
      github: null,
    },

    {
      name: "Foodify",
      description:
        "Foodify, a web platform I developed and presented in a team of 4 as part of my Engineering College Thesis Project. Foodify is a web platform that connects home culinary enthusiasts with recipes tailored to their needs. My role included the complete setup and design of the backend server, API's, and database, as well as implementing the Search and Home Feed Related Pages. I was also the main UX Designer for all the pages across the web platform, for which I utilized Figma. We built this using the MERN Stack (MongoDB, Express.js, React.js, Node.js), Google Auth, Google FireBase, and MongoDB Atlas. As part of this project we had regular team check-ins, weekly advisor meetings, and montly status reports.",
      image: imgFoodify,
      link: "https://github.com/mohammadsleiman/Foodify.us",
      location: "San Jose, CA",
      github: "https://github.com/mohammadsleiman/foodify.us",
    },

    {
      name: "SCE @ SJSU",
      description:
        "SCE is the largest Computer Science & Computer Engineering organization on the SJSU campus, and works closely with the College of Engineering, where I served as a software development team officer. My role included designing new Data Objects and revamping API's across the 10,000 line codebase to support them. I mainly worked with Node JS. It is currently used by over 300+ organization members.",
      image: imgSCE,
      link: "https://sce.sjsu.edu/",
      location: "San Jose State University",
      linkedin: "https://www.linkedin.com/company/sjsusce",
      github: "https://github.com/SCE-Development/Core-v4",
    },
  ];
  return (
    <div className="experiences-container">
      <h1 className="title-my-work">My work</h1>
      <div className="experiences-cards-container">
        {experienceData.map((experience) => {
          return <ExperienceCard experienceData={experience} />;
        })}
      </div>
    </div>
  );
}
